import Highcharts from "highcharts";
import { FUNNEL_CHART_CONFIG } from "src/config/charts/funnelChartConfig";
import type { FunnelStage } from "../types";

type FunnelApiData = {
  stages?: FunnelStage[];
};

export const renderFunnel = (
  data: unknown,
  spec: unknown,
  title: string,
  onPointClick?: (point: unknown) => void,
): Highcharts.Options => {
  const funnelChartData = data as FunnelApiData;
  const onStageClick = onPointClick as
    | ((stage: FunnelStage) => void)
    | undefined;

  const stages = [...(funnelChartData?.stages ?? [])].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0),
  );

  return {
    ...FUNNEL_CHART_CONFIG,
    // title: {
    //   text: title,
    //   align: "left",
    // },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const point = this.point as any;
        const description: string = point.options?.custom?.description ?? "";
        const percentage: number = point.options?.custom?.percentage ?? 0;
        const hasBreakdown = point.options?.custom?.hasBreakdown;
        return `<b>${point.name}</b><br/>Count: <b>${(point.y as number)?.toLocaleString()}</b><br/>Percentage: <b>${percentage}%</b>${description ? `<br/><span style="color:#666">${description}</span>` : ""}${hasBreakdown ? `<br/><span style="color:#6366f1;font-size:0.75em">Click to see breakdown</span>` : ""}`;
      },
    },
    plotOptions: {
      funnel: {
        ...((FUNNEL_CHART_CONFIG.plotOptions as any)?.funnel ?? {}),
        cursor: onStageClick ? "pointer" : undefined,
        dataLabels: {
          enabled: true,
          softConnector: true,
          formatter: function () {
            const point = this.point as any;
            const percentage: number = point.options?.custom?.percentage ?? 0;
            return `<b>${point.name}</b>: ${(point.y as number)?.toLocaleString()} (${percentage}%)`;
          },
        },
        point: onStageClick
          ? {
              events: {
                click: function (this: any) {
                  const stageName: string = this.name;
                  const stage = stages.find((s) => s.name === stageName);
                  if (stage) onStageClick(stage);
                },
              },
            }
          : undefined,
      },
    },
    series: [
      {
        type: "funnel",
        name: "Count",
        colorByPoint: true,
        data: stages.map((stage) => ({
          name: stage.name,
          y: stage.count,
          color: stage.color,
          custom: {
            description: stage.description ?? "",
            percentage: stage.percentage,
            hasBreakdown:
              stage.breakdown != null &&
              Object.keys(stage.breakdown).length > 0,
          },
        })),
      } as Highcharts.SeriesFunnelOptions,
    ],
  };
};
